import request from "@/utils/request.js";
import { teachingPlatformApi } from "@/config/deploy.js";
//获取测评列表
export function getUserTestingList(params) {
  return request({
    url: teachingPlatformApi + "/app/testing/getUserTestingList",
    method: "post",
    data: params,
    showLoading: false
  });
}
//考试须知
export function getTestInstructionsById(params) {
  return request({
    closeInterceptors: true,
    url: teachingPlatformApi + "/app/testing/getTestInstructionsById",
    method: "post",
    data: params
  });
}
/**
 * 检查用户信息（医院、科室、职称、参加工作时间）
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserNurseCheck(params) {
  return request({
    url: "/userService/api/app/userNurse/getUserNurseCheck",
    method: "post",
    data: params
  });
}
/**
 * 检查用户信息（医院、科室、职称、参加工作时间）
 * @param params
 * @returns {AxiosPromise}
 */
export function testingAgainFlag(params) {
  return request({
    url: teachingPlatformApi + "/app/testing/testingAgainFlag",
    method: "post",
    data: params
  });
}
/**
 * 判断用户是否加入机构
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserIsJoinType(params) {
  return request({
    url: teachingPlatformApi + "/app/orgUser/getUserIsJoinType",
    method: "post",
    data: params,
    showLoading: false
  });
}
/**
 *判断考试时间是否结束
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserTestingSurplusInfo(params) {
  return request({
    url: teachingPlatformApi + "/app/testing/getUserTestingSurplusInfo",
    method: "post",
    data: params
  });
}
